<template>
  <div class="step2">
    <ValidateForm ref="editForm" :formItems="formItems" />
    <!-- <Alert v-if="tipsVisible" type="warning">{{ $config.unitAddress }}</Alert> -->
    <Alert v-if="tipsVisible" type="warning" v-for="(s, index) in $config.searchTips" :key="index"><span
        v-html="s"></span></Alert>
    <div v-if="!readonly" class="privacy">
      <div>
        <Checkbox v-model="privacy">我已详细阅读和同意</Checkbox>
      </div>
      <div>
        <a class="text-link" href="/用户服务协议.html" target="_blank">《用户服务协议》</a>和<a class="text-link" href="/隐私政策.html"
          target="_blank">《隐私政策》</a>
      </div>
    </div>
    <div class="operation operation-bottom">
      <Button v-if="!modify" type="primary" @click="$emit('on-prev')">上一步</Button>
      <Button type="primary" :disabled="!readonly && !privacy" @click="handleNext">下一步</Button>
    </div>
  </div>
</template>

<script>
import ValidateForm from '@components/validate-form'
import { editForm } from './editForm'
export default {
  name: 'step2',
  components: { ValidateForm },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    modify: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      item: {},
      formItems: [],
      tipsVisible: true,
      privacy: false
    }
  },
  mounted() {
    this.item = this.data
    this.buildFormItems()
  },
  methods: {
    async buildFormItems() {
      try {
        const formItems = await editForm.call(this)
        this.$set(this, 'formItems', formItems)
      } catch (e) {
        console.error(e)
      }
    },
    async handleNext() {
      const item = await this.$refs['editForm'].submit()
      if (item) {
        item.SID = this.item.sid
        this.$emit('on-params', item)
        this.$emit('on-next')
      }
    },
    setItemsValue() {
      const { item } = this
      this.formItems.map(m => {
        const { key, type } = m
        if (key === 'SubscribeZQDate') {
          // 预约日期
          m.hide = item['ResultStyle'] === 'EMS'
          if (!item[key]) return
          const temp = item[key].split('')
          temp.splice(4, 0, '-')
          temp.splice(7, 0, '-')
          m.value = item[key] && new Date(temp.join(''))
        } else if (key === 'CompanyName') {
          // 单位名称
          m.hide = item['SubscribeType'] === 'User'
          m.value = item[key]
        } else if (key === 'EmsAddress') {
          // 通讯地址
          m.hide = item['ResultStyle'] === 'ZQ'
          m.value = item[key]
        } else if (type === 'date') {
          m.value = item[key] && new Date(item[key])
        } else {
          this.$set(m, 'value', item[key])
        }
        // 阅读模式
        if (this.readonly) {
          m.disabled = this.readonly
          m.rules = []
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.step2 {
  position: relative;

  .privacy {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 16px auto;

    .text-link {
      color: #0388dd;
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
</style>
